// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"072c3f79","313":"2d276097","425":"d86d5ac3","484":"7892434c","980":"99a5d62a"}[chunkId] + ".chunk.js";
};